// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"563":"2242f429","943":"91eeab6e"}[chunkId] + ".chunk.css";
};